'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { storyblokInit, apiPlugin } from 'gatsby-source-storyblok';
import Header from './core/Header';
import Footer from './core/Footer';
import Main from './core/Main';
import { ThemeProvider } from 'styled-components';
import defaultTheme from '../styles/themes/default.theme';
import GlobalStyle from '../styles/global';
import { ILocation } from '../types';
import { SiteSettingsProvider } from '../context/SiteSettingsContext';
import useSiteSettingsData from '../data/useSiteSettingsData';
import { CookieBannerProvider } from '../context/CookieBannerContext';

storyblokInit({
  accessToken: process.env.GATSBY_STORYBLOK_API_KEY,
  apiOptions: {
    region: 'eu',
  },
  use: [apiPlugin],
});

const Layout = ({
  children,
  location,
  headerSettings,
  hideFooter,
}: {
  children: any;
  location: ILocation;
  headerSettings?: {
    text_color: 'white' | 'black';
    position: 'fixed' | 'absolute';
    banner?: boolean;
    desktopPosition?: 'fixed' | 'absolute';
  };
  hideFooter?: boolean;
}) => {
  const { pathname } = location;

  const parsedSetting = useSiteSettingsData({ pathname });

  return (
    <CookieBannerProvider>
      <ThemeProvider theme={defaultTheme}>
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=GTM-WT74NXMN`}
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          ></iframe>
        </noscript>
        <GlobalStyle />
        <SiteSettingsProvider siteSettings={parsedSetting}>
          <Header
            settings={parsedSetting}
            text_color={headerSettings?.text_color}
            position={headerSettings?.position}
            banner={headerSettings?.banner}
            desktopPosition={headerSettings?.desktopPosition}
            globalBannerSetting={parsedSetting?.show_banner}
          />
          <Main>{children}</Main>
          {!hideFooter && <Footer settings={parsedSetting} />}
        </SiteSettingsProvider>
      </ThemeProvider>
    </CookieBannerProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
